import { WidgetType } from 'widgets/WidgetType';
import State from 'store/State';
import { selectWidgetInstanceState } from 'widgets/store/selectors';
import { useSelector } from 'react-redux';
import { WidgetWithComponentState } from 'widgets/store/component/WidgetWithComponentState';

export function selectWidgetComponentState<TComponentState>(
    state: State,
    widgetType: WidgetType,
    widgetKey: string
): TComponentState | undefined {
    const widgetState = selectWidgetInstanceState(state, widgetType, widgetKey);
    return (widgetState as WidgetWithComponentState<TComponentState>)
        ?.component;
}

export const useWidgetComponentState = <TComponentState>(
    widgetType: WidgetType,
    widgetKey: string
) =>
    useSelector((state: State) =>
        selectWidgetComponentState<TComponentState>(
            state,
            widgetType,
            widgetKey
        )
    );
